<template>
  <div class="questionnaire">
    <h2 class="questionnaire-title">Compliance Questionnaire</h2>
    <!-- <div></div> -->
    <div v-for="(moduleQuestion,index) in modulesQuestionData" :key="index" class="questionnaire-moudle">
      <div class="questionnaire-moudle-title">{{ num[index] + '.' +moduleQuestion.en_name }}</div>
      <el-descriptions :column="1" border :content-style="contentStyle">
        <el-descriptions-item v-for="(question,qIndex) in moduleQuestion.questionList" :key="qIndex" class="descriptions-item">
          <template slot="label">
            {{ qIndex + 1 + '.' + question.question }} {{ question.question_type === 1? '(single select)' : '(multi-select)' }}
          </template>
          <el-radio-group
            v-if="question.question_type === 1"
            v-model="question.questionValue"
            :class="{
              'line-single': question && question.mch_naire_option_list.length>2
            }"
            size="small"
          >

            <template
              v-for="(rItem,rIndex) in question.mch_naire_option_list"
            >
              <el-radio
                :key="rIndex"
                :label="rItem.id"
              >
                <span class="checkbox_content"> {{ rItem.option_value }}</span>
              </el-radio>
            </template>
          </el-radio-group>
          <el-checkbox-group
            v-if="question.question_type === 2"
            v-model="question.questionValue"
            size="small"
          >
            <template v-for="(cItem,cIndex) in question.mch_naire_option_list">
              <el-checkbox
                :key="cIndex"
                :class="{
                  'line-single': question && question.mch_naire_option_list.length>2
                }"
                :label="cItem.id"
              ><span class="checkbox_content"> {{ cItem.option_value }}</span>
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="tip-title">{{ tipQuestionData[0] && tipQuestionData[0].en_name }}</div>
    <div class="tip-content">
      {{ tipQuestionData[0] && tipQuestionData[0].questionList[0] && tipQuestionData[0].questionList[0].question }}
    </div>
    <div class="btn-conatiner">
      <el-button type="primary" :disabled="submiting" @click="onClickSubmitBtn">{{ $t('components.submit') }}</el-button>
    </div>
  </div>

</template>

<script>
import { fetchNaireQuestionOptions, fetchNaireTitle, sendNaireAnswer } from '@/api/questionnaire/questionnaire'

export default {
  name: 'Merchant_Info',
  components: {

  },
  props: {
    merchantId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    this.contentStyle = { 'width': '60%' }
    this.num = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX']
    return {
      questionLength: 0,
      submiting: false,
      modulesQuestionData: [{}],
      tipQuestionData: [{ questionList: [{ mch_naire_option_list: [] }] }]
    }
  },
  created() {
    this.getQuestionOptions()
  },

  methods: {
    getQuestionOptions() {
      Promise.all([fetchNaireQuestionOptions(), fetchNaireTitle()]).then(values => {
        const [questionRes, titleRes] = values
        if (questionRes.code === 1 && titleRes.code === 1) {
          const questionData = questionRes.data
          const titlenData = titleRes.data
          this.questionLength = questionData.length - 1
          const allTitleData = titlenData.map((titleItem, titleIndex) => {
            titleItem.questionList = questionData.filter(questionItem => {
              questionItem.questionValue = null
              if (questionItem.question_type === 2) {
                questionItem.questionValue = []
              }
              return questionItem.question_title === titleItem.nm_code
            })
            return titleItem
          })
          this.modulesQuestionData = allTitleData.filter(allItem => allItem.nm_code !== 99)
          this.tipQuestionData = allTitleData.filter(allItem => allItem.nm_code === 99)
        }
      })
    },
    getParams() {
      const answer_list = []
      this.modulesQuestionData.forEach((moudleItem, moudleIndex) => {
        moudleItem.questionList.forEach((questionItem, questionIndex) => {
          const answer = {
            question_id: questionItem.id,
            option_id: questionItem.questionValue
          }

          if (questionItem.question_type === 2) {
            answer.option_id = answer.option_id.join(',')
          }
          if (answer.option_id) {
            answer_list.push(answer)
          }
        })
      })
      return { answer_list }
    },
    onClickSubmitBtn() {
      const params = this.getParams()
      if (params.answer_list.length < this.questionLength) {
        this.$message.warning('Please complete!')
        return
      }
      this.submiting = true
      sendNaireAnswer(params).then((res) => {
        this.$message.success('Submit')
        // 更新user信息
        this.$store.dispatch('user/getInfo')
        setTimeout(() => {
          this.$nextTick(() => {
            this.$router.push('/')
          })
        }, 500)
      }).finally(() => {
        this.submiting = false
      })
    }

  }
}
</script>
<style  scoped>
.questionnaire{
  padding: 30px;
}
.questionnaire-title{
  margin: 15px 0 0 0;
  text-align: center;
}
.questionnaire-moudle-title{
  padding: 15px 0 15px 5px;
  margin: 30px 0 10px 0;
  background: #999;
  color: #000;
}
.tip-title{
  margin-top: 50px;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  background: #000;
  color: #fff
}
.tip-content{
  margin-top: 20px;
  text-indent: 2em;
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
}

.line-single .el-radio,.el-checkbox{
 /* display: block; */
 margin: 10px 0;
 display: flex;
 justify-items: center;
 line-height: 1.5;
}
.btn-conatiner{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.checkbox_content{
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;

}

</style>
